import { CommonModule } from '@angular/common';
import { Component, OnInit, inject, effect, signal, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { FilterModel } from '../../model/filter-model';
import { VideoQueryElementsComponent } from "../video-query-elements/video-query-elements.component";
import { AnalysisStore } from 'src/app/pages/analysis/store/analysis.store';

@Component({
  selector: 'app-video-filter',
  templateUrl: 'video-filter.component.html',
  styleUrls: ['video-filter.component.scss'],
  standalone: true,
  imports: [
    CommonModule, FormsModule, MatIcon,
    VideoQueryElementsComponent
  ],
})
export class VideoFilterComponent implements OnInit {

  readonly onFiltersApplied = output<void>();

  readonly store = inject(AnalysisStore);

  readonly filters = signal<FilterModel>({
    gender: '',
    category: '',
    competition: '',
    dateStart: '',
    dateEnd: ''
  });

  constructor() {
    effect(() => {
      const storeFilters = this.store.filters();
      if (storeFilters) {
        this.filters.set({
          gender: storeFilters.gender || '',
          category: storeFilters.category ? String(storeFilters.category) : '',
          competition: storeFilters.competition ? String(storeFilters.competition) : '',
          dateStart: storeFilters.dateStart ? new Date(storeFilters.dateStart).toISOString().split('T')[0] : '',
          dateEnd: storeFilters.dateEnd ? new Date(storeFilters.dateEnd).toISOString().split('T')[0] : ''
        });
      } else {
        this.filters.set({
          gender: '',
          category: '',
          competition: '',
          dateStart: '',
          dateEnd: '',
        });
      }
    }, { allowSignalWrites: true });
  }

  ngOnInit() {
  }

  applyFilters() {
    if (!this.isFilterApplied()) {
      this.store.applyFilters(null);
      this.onFiltersApplied.emit();
      return;
    }

    const currentFilters = this.filters();
    const filtersToApply = {
      ...currentFilters,
      dateStart: currentFilters.dateStart ? new Date(currentFilters.dateStart).getTime() : null,
      dateEnd: currentFilters.dateEnd ? new Date(currentFilters.dateEnd).getTime() : null
    };

    this.store.applyFilters(filtersToApply as any);
    this.onFiltersApplied.emit();
  }

  isFilterApplied() {
    return Object.values(this.filters()).some(value => value);
  }

  resetFilters() {
    this.filters.set({
      gender: '',
      category: '',
      competition: '',
      dateStart: '',
      dateEnd: '',
    });
    this.applyFilters();
  }

}
